import { NAMES } from './bibles'

// Sigla i inne nazwy ksiąg (Biblia Tysiąclecia, Biblia Warszawska, angielskie) – pełne nazwy z NAMES
// są dodawane automatycznie. Klucze są porównywane po normalizacji (małe litery, bez polskich znaków,
// spacji i kropek).
const BOOKS = {
  1: ['Rdz', 'Rodz', '1 Mojż', '1 Mojżeszowa', '1 M', 'Gen', 'Gn', 'Ge'],
  2: ['Wj', 'Wyj', '2 Mojż', '2 Mojżeszowa', '2 M', 'Exod', 'Ex'],
  3: ['Kpł', 'Kapł', 'Kp', '3 Mojż', '3 Mojżeszowa', '3 M', 'Lev', 'Lv'],
  4: ['Lb', 'Licz', '4 Mojż', '4 Mojżeszowa', '4 M', 'Num', 'Nm', 'Nb'],
  5: ['Pwt', 'Powt', '5 Mojż', '5 Mojżeszowa', '5 M', 'Deut', 'Dt'],
  6: ['Joz', 'Jozue', 'Josh', 'Jos'],
  7: ['Sdz', 'Sędz', 'Judg', 'Jdg'],
  8: ['Rt', 'Ru'],
  9: ['1 Sm', '1 Sam', '1 Sa'],
  10: ['2 Sm', '2 Sam', '2 Sa'],
  11: ['1 Krl', '1 Król', '1 Królów', '1 Kgs', '1 Ki'],
  12: ['2 Krl', '2 Król', '2 Królów', '2 Kgs', '2 Ki'],
  13: ['1 Krn', '1 Kron', '1 Chron', '1 Chr', '1 Ch'],
  14: ['2 Krn', '2 Kron', '2 Chron', '2 Chr', '2 Ch'],
  15: ['Ezd', 'Ezdrasz', 'Ezr'],
  16: ['Ne', 'Neh', 'Nehemiasz'],
  17: ['Est', 'Estera', 'Esth'],
  18: ['Hi', 'Hiob', 'Jb'],
  19: ['Ps', 'Psalm', 'Psalmy', 'Psa', 'Pss'],
  20: ['Prz', 'Przyp', 'Przypowieści', 'Prov', 'Prv', 'Pr'],
  21: ['Koh', 'Kazn', 'Koheleta', 'Kohelet', 'Eklezjastes', 'Eccl', 'Ecc', 'Qoh'],
  22: ['Pnp', 'Pieśń', 'Pieśni', 'Song of Solomon', 'Song', 'Sg', 'SoS'],
  23: ['Iz', 'Izaj', 'Izajasz', 'Isa', 'Is'],
  24: ['Jr', 'Jer', 'Jeremiasz'],
  25: ['Lm', 'Tr', 'Lamentacje', 'Lam'],
  26: ['Ez', 'Ezech', 'Ezechiel', 'Ezek', 'Ezk'],
  27: ['Dn', 'Dan'],
  28: ['Oz', 'Ozeasz', 'Hos'],
  29: ['Jl'],
  30: ['Am'],
  31: ['Ab', 'Abd', 'Abdiasz', 'Obad', 'Ob'],
  32: ['Jon', 'Jonasz', 'Jnh'],
  33: ['Mi', 'Mich', 'Micheasz', 'Mic'],
  34: ['Na', 'Nah'],
  35: ['Ha', 'Hab', 'Habakuk'],
  36: ['So', 'Sof', 'Sofoniasz', 'Zeph', 'Zep'],
  37: ['Ag', 'Agg', 'Aggeusz', 'Hag', 'Hg'],
  38: ['Za', 'Zach', 'Zachariasz', 'Zech', 'Zec'],
  39: ['Ml', 'Mal', 'Malachiasz'],
  40: ['Mt', 'Mat', 'Mateusz', 'Matt'],
  41: ['Mk', 'Mar', 'Marek', 'Mrk'],
  42: ['Łk', 'Łuk', 'Łukasz', 'Lk'],
  43: ['J', 'Jan', 'Jn', 'Jhn'],
  44: ['Dz', 'Dzieje', 'Dz Ap', 'Act'],
  45: ['Rz', 'Rzym', 'Rom', 'Rm'],
  46: ['1 Kor', '1 Cor', '1 Co'],
  47: ['2 Kor', '2 Cor', '2 Co'],
  48: ['Ga', 'Gal'],
  49: ['Ef', 'Efez', 'Eph'],
  50: ['Flp', 'Filip', 'Phil', 'Php'],
  51: ['Kol', 'Col'],
  52: ['1 Tes', '1 Thess', '1 Th'],
  53: ['2 Tes', '2 Thess', '2 Th'],
  54: ['1 Tm', '1 Tym', '1 Tim', '1 Ti'],
  55: ['2 Tm', '2 Tym', '2 Tim', '2 Ti'],
  56: ['Tt', 'Tyt', 'Tit'],
  57: ['Flm', 'Filem', 'Phlm', 'Phm'],
  58: ['Hbr', 'Hebr', 'Heb'],
  59: ['Jk', 'Jak', 'Jas', 'Jm'],
  60: ['1 P', '1 Pt', '1 Piotr', '1 Pet', '1 Pe'],
  61: ['2 P', '2 Pt', '2 Piotr', '2 Pet', '2 Pe'],
  62: ['1 J', '1 Jan', '1 Jn'],
  63: ['2 J', '2 Jan', '2 Jn'],
  64: ['3 J', '3 Jan', '3 Jn'],
  65: ['Jud', 'Juda', 'Jd'],
  66: ['Ap', 'Obj', 'Apokalipsa', 'Rev', 'Apocalypse']
}

// Słowa pomijane w nazwie księgi, np. „Ks. Rodzaju”, „List do Rzymian”, „Ewangelia wg św. Jana”.
const FILLER = new Set([
  'ks', 'ksiega', 'ksiegi', 'list', 'do', 'ew', 'ewangelia', 'wg', 'wedlug', 'sw', 'swietego',
  'the', 'book', 'of', 'gospel', 'according', 'to', 'st', 'saint'
])

// Sigla, które są też zwykłymi słowami – bez numeru rozdziału traktujemy je jako wyszukiwaną frazę.
const AMBIGUOUS = new Set([
  'na', 'za', 'mi', 'so', 'am', 'ab', 'ha', 'ag', 'hi', 'is', 'ex', 'ne', 'tr', 'ob', 'pr',
  'jak', 'job', 'mar', 'mark', 'acts', 'act', 'song'
])

const ROMAN = {i: 1, ii: 2, iii: 3}

export const normalize = text => text
  .toLowerCase()
  .replace(/ł/g, 'l')
  .normalize('NFD')
  .replace(/\p{M}/gu, '')

const toKey = name => {
  const tokens = normalize(name).split(/[\s.]+/).filter(Boolean)
  const words = tokens.filter(token => !FILLER.has(token))

  return (words.length ? words : tokens).join('')
}

const ALIASES = new Map(Object.entries(BOOKS).flatMap(([book, names]) => (
  [NAMES.pl[book - 1], NAMES.en[book - 1], ...names].map(name => [toKey(name), +book])
)))

// Zwraca numer księgi dla nazwy lub sigli, np. „1 Kor”, „I Kor”, „1Kor”, „Ew. Jana”, „Rodz”.
// Z `prefix` dopasowuje też jednoznaczne początki nazw, np. „Izaj” albo „Kapł”.
export const findBook = (name, {prefix = false, bare = false} = {}) => {
  const key = toKey(name)
  const roman = key.match(/^(i{1,3})([a-z]+)$/)
  const keys = roman ? [`${ROMAN[roman[1]]}${roman[2]}`, key] : [key]

  if (bare && AMBIGUOUS.has(key)) return null

  for (const key of keys) {
    if (ALIASES.has(key)) return ALIASES.get(key)
  }

  if (prefix) {
    for (const key of keys) {
      if (key.replace(/^\d/, '').length < 3) continue

      const matches = new Set([...ALIASES].filter(([alias]) => alias.startsWith(key)).map(([, book]) => book))

      if (matches.size == 1) return [...matches][0]
    }
  }

  return null
}

// Zwraca wszystkie księgi pasujące do nazwy lub jej początku, np. „Kor” → 1 i 2 Koryntian.
// Bez numeru rozdziału (`bare`) wymaga dłuższego początku, żeby nie podpowiadać przy zwykłych słowach.
export const findBooks = (name, {bare = false} = {}) => {
  const exact = findBook(name, {bare})
  const key = toKey(name)
  const roman = key.match(/^(i{1,3})([a-z]+)$/)
  const keys = roman ? [`${ROMAN[roman[1]]}${roman[2]}`, key] : [key]
  const books = new Set()

  if (exact) return [exact]
  if (bare && AMBIGUOUS.has(key)) return []

  for (const key of keys) {
    if (key.replace(/^\d/, '').length < (bare ? 3 : 2)) continue

    for (const [alias, book] of ALIASES) {
      (alias.startsWith(key) || !/^\d/.test(key) && alias.replace(/^\d/, '').startsWith(key)) && books.add(book)
    }
  }

  return [...books].sort((a, b) => a - b)
}
